import { loginRedirect } from './auth';
import {
    openSystemNotification,
    openValidationNotification
} from '../../../store/notifications/actions';
import { appStore } from '../../index';

export const responseSuccess = res => res;

export const responseError = ({ response }) => {
    responseAction(response);

    return Promise.reject(response && response.data);
};

function responseAction (response) {
    if (response) {
        const {status, data} = response;
        if (status === 401) {
            return loginRedirect(data);
        }

        const { dispatch } = appStore;
        if (data.validationErrors) {
            if (data.validationErrors.length === 1) {
                const nameVal = data.validationErrors.find(err => err.fieldName === 'name');
                if (nameVal) return;
            }
            return dispatch(openValidationNotification(data.validationErrors));
        }
        return dispatch(openSystemNotification(data.message));
    } else {
        const { dispatch } = appStore;
        return dispatch(openSystemNotification('Unknown error'));
   }
}

